(function () {
  var cache = window.__nestPdpThumbnailImageCache20260810 || {};
  window.__nestPdpThumbnailImageCache20260810 = cache;

  function isMobile() {
    return window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
  }

  function visibleLimit() {
    return 8;
  }

  function immediatePreloadLimit() {
    return 8;
  }

  function largeUrl(thumbnail) {
    var attribute = isMobile() ? 'data-large-src-mobile' : 'data-large-src-desktop';
    return thumbnail.getAttribute(attribute) || thumbnail.getAttribute('data-large-src');
  }

  function syncLargeSources(root) {
    if (!root || !root.querySelectorAll) return;

    Array.prototype.forEach.call(
      root.querySelectorAll('.product-detail-description-left-small[data-large-src]'),
      function (thumbnail) {
        var url = largeUrl(thumbnail);
        if (url) thumbnail.setAttribute('data-large-src', url);
      }
    );
  }

  function cachedImage(url) {
    if (!url) return null;
    if (cache[url]) return cache[url];

    var image = new Image();
    image.decoding = 'async';
    image.src = url;
    cache[url] = image;
    return image;
  }

  function preloadThumbnails(thumbnails) {
    thumbnails.forEach(function (thumbnail) {
      cachedImage(largeUrl(thumbnail));
    });
  }

  function preloadWhenIdle(thumbnails) {
    if (!thumbnails.length) return;

    var load = function () {
      preloadThumbnails(thumbnails);
    };

    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(load, { timeout: 1500 });
    } else {
      window.setTimeout(load, 600);
    }
  }

  function preload(root) {
    if (!root || !root.querySelectorAll) return;

    syncLargeSources(root);

    var thumbnails = Array.prototype.slice.call(
      root.querySelectorAll('.product-detail-description-left-small[data-large-src]')
    ).slice(0, visibleLimit());
    var immediateCount = immediatePreloadLimit();

    preloadThumbnails(thumbnails.slice(0, immediateCount));
    preloadWhenIdle(thumbnails.slice(immediateCount));
  }

  function applyHighResolutionHero(thumbnail) {
    var root = thumbnail.closest('.product-template__container');
    var hero = root && root.querySelector('.product-detail-description-left-large');
    var url = largeUrl(thumbnail);

    if (!hero || !url) return;

    var requestId = (hero.__nestPdpImageRequestId || 0) + 1;
    var preview = thumbnail.style.backgroundImage;
    hero.__nestPdpImageRequestId = requestId;

    if (preview && preview !== 'none') {
      hero.style.backgroundImage = preview;
      if (hero.classList.contains('nest-variant-surface')) {
        hero.style.setProperty('--nest-variant-surface-image', preview);
      }
    }

    var image = cachedImage(url);
    if (!image) return;

    function paintHighResolution() {
      if (hero.__nestPdpImageRequestId !== requestId) return;
      var value = 'url("' + url.replace(/"/g, '\\"') + '")';
      hero.style.backgroundImage = value;
      if (hero.classList.contains('nest-variant-surface')) {
        hero.style.setProperty('--nest-variant-surface-image', value);
      }
    }

    if (image.complete && image.naturalWidth) {
      paintHighResolution();
    } else {
      image.addEventListener('load', paintHighResolution, { once: true });
    }
  }

  function thumbnailFromEvent(event) {
    if (!event.target || !event.target.closest) return null;
    return event.target.closest(
      '.product-template__container .product-detail-description-left-small[data-large-src]'
    );
  }

  function preloadAll() {
    Array.prototype.forEach.call(
      document.querySelectorAll('.product-template__container'),
      preload
    );
  }

  function schedule() {
    window.setTimeout(preloadAll, 0);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, { once: true });
  } else {
    schedule();
  }

  document.addEventListener('shopify:section:load', function (event) {
    preload(event.target);
  });

  document.addEventListener('mouseover', function (event) {
    var thumbnail = thumbnailFromEvent(event);
    if (thumbnail) applyHighResolutionHero(thumbnail);
  });

  document.addEventListener('click', function (event) {
    var thumbnail = thumbnailFromEvent(event);
    if (thumbnail) applyHighResolutionHero(thumbnail);
  });

  var persistentVariantSurfaceHandles = {
    'sparrow-signature-hybrid-mattress': true,
    'owl-natural-latex-hybrid-mattress': true,
    'starling-signature-contour-grid': true
  };

  function currentProductHandle() {
    var match = window.location.pathname.match(/^\/products\/([^/?#]+)/);
    return match ? match[1] : '';
  }

  function normalizedUrl(value) {
    try {
      return new URL(String(value || '').trim(), window.location.origin).href;
    } catch (error) {
      return String(value || '').trim();
    }
  }

  function normalizedOption(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function mainProductForm(root) {
    return root && root.querySelector('.product-detail-description-right form[data-product-form]');
  }

  function mainVariantCodes(root) {
    var form = mainProductForm(root);
    return form ? form.querySelectorAll('.variants-codes .variant-code') : [];
  }

  function mainVariantSelectors(root) {
    var form = mainProductForm(root);
    return form ? form.querySelectorAll('.product-detail-option-select') : [];
  }

  function mainSelectorFromEvent(event) {
    if (!event.target || !event.target.closest) return null;
    var selector = event.target.closest('.product-detail-option-select');
    var root = selector && selector.closest('.product-template__container');
    var form = root && mainProductForm(root);
    return selector && form && selector.closest('form') === form ? selector : null;
  }

  function optionSignature(root) {
    return Array.prototype.map.call(mainVariantSelectors(root), function (selector) {
      return normalizedOption(selector.value);
    }).join('||');
  }

  function selectedVariantCode(root) {
    var selectors = mainVariantSelectors(root);
    var values = Array.prototype.map.call(selectors, function (selector) {
      return normalizedOption(selector.value);
    });
    var codes = mainVariantCodes(root);

    for (var index = 0; index < codes.length; index += 1) {
      var code = codes[index];
      var matches = true;
      for (var optionIndex = 0; optionIndex < values.length; optionIndex += 1) {
        if (normalizedOption(code.getAttribute('data-option-' + (optionIndex + 1))) !== values[optionIndex]) {
          matches = false;
          break;
        }
      }
      if (matches) return code;
    }
    return null;
  }

  function assignedImageUrl(code) {
    var image = code && code.querySelector('.variant-code-image');
    if (!image) return '';
    var attribute = isMobile() ? 'data-large-src-mobile' : 'data-large-src-desktop';
    return normalizedUrl(image.getAttribute(attribute) || image.textContent);
  }

  function heroImageValue(url) {
    return 'url("' + String(url || '') + '")';
  }

  function installPersistentSurfaceStyle() {
    if (document.getElementById('nest-persistent-variant-surface-style')) return;
    var style = document.createElement('style');
    style.id = 'nest-persistent-variant-surface-style';
    style.textContent = [
      '.product-detail-description-left-large.nest-variant-surface{position:relative!important;isolation:isolate;background-image:none!important;}',
      '.product-detail-description-left-large.nest-variant-surface::before{',
      'content:"";position:absolute;inset:0;z-index:-1;pointer-events:none;',
      'background-image:var(--nest-variant-surface-image);',
      'background-position:center center;background-size:cover;background-repeat:no-repeat;',
      '}',
    ].join('');
    (document.head || document.documentElement).appendChild(style);
  }

  function setPersistentSurfaceImage(root, url) {
    var hero = root && root.querySelector('.product-detail-description-left-large');
    if (hero && url) hero.style.setProperty('--nest-variant-surface-image', heroImageValue(url));
  }

  function preloadAssignedVariantImages(root) {
    Array.prototype.forEach.call(mainVariantCodes(root), function (code) {
      cachedImage(assignedImageUrl(code));
    });
  }

  function showSelectedVariantImage(root) {
    var url = assignedImageUrl(selectedVariantCode(root));
    if (!url) return;
    var image = cachedImage(url);
    var paint = function () { setPersistentSurfaceImage(root, url); };
    if (image && image.complete && image.naturalWidth) {
      paint();
    } else if (image) {
      image.addEventListener('load', paint, { once: true });
    }
  }

  function installPersistentVariantSurface(root) {
    if (!persistentVariantSurfaceHandles[currentProductHandle()] || !root) return;
    var hero = root.querySelector('.product-detail-description-left-large');
    var selectors = mainVariantSelectors(root);
    if (!hero || !selectors.length || hero.classList.contains('nest-variant-surface')) return;

    installPersistentSurfaceStyle();
    var currentImage = hero.style.backgroundImage || window.getComputedStyle(hero).backgroundImage;
    if (currentImage && currentImage !== 'none') {
      hero.style.setProperty('--nest-variant-surface-image', currentImage);
    }
    hero.classList.add('nest-variant-surface');
    root.__nestLastVariantSignature = optionSignature(root);
    preloadAssignedVariantImages(root);

    root.__nestPersistentVariantWatcher = window.setInterval(function () {
      var signature = optionSignature(root);
      if (!signature || signature === root.__nestLastVariantSignature) return;
      root.__nestLastVariantSignature = signature;
      showSelectedVariantImage(root);
    }, 75);
  }

  function installPersistentVariantSurfaces() {
    Array.prototype.forEach.call(
      document.querySelectorAll('.product-template__container'),
      installPersistentVariantSurface
    );
  }

  if (persistentVariantSurfaceHandles[currentProductHandle()]) {
    document.addEventListener('change', function (event) {
      var selector = mainSelectorFromEvent(event);
      var root = selector && selector.closest('.product-template__container');
      if (!root) return;
      root.__nestLastVariantSignature = optionSignature(root);
      showSelectedVariantImage(root);
    }, true);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', installPersistentVariantSurfaces, { once: true });
    } else {
      installPersistentVariantSurfaces();
    }

    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target && event.target.closest
        ? event.target.closest('.product-template__container')
        : null;
      installPersistentVariantSurface(root || event.target);
    });
  }

  var resizeTimer;
  window.addEventListener('resize', function () {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(preloadAll, 120);
  }, { passive: true });
})();
